import React from 'react';
import { ICON_PATHS } from './iconPaths';

export function Icon({ name, className = '', title }) {
  const markup = ICON_PATHS[name] || '';
  return (
    <svg
      className={`ico ${className}`.trim()}
      viewBox="0 0 24 24"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      aria-label={title}
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}

let logoSeq = 0;

export function Logo({ size = 28 }) {
  const [gradientId] = React.useState(() => `vlg-${++logoSeq}`);
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0e8fd3" />
          <stop offset="1" stopColor="#0d9488" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${gradientId})`} />
      <path d="M8.5 9.5 16 22.5l7.5-13" stroke="#fff" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="8.5" cy="9.5" r="2.4" fill="#fff" />
      <circle cx="16" cy="22.5" r="2.4" fill="#fff" />
      <circle cx="23.5" cy="9.5" r="2.4" fill="#9ff0de" />
    </svg>
  );
}

export function MicrosoftLogo({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

export const ICON_NAMES = Object.keys(ICON_PATHS);
